<script>
import { Doughnut } from 'vue-chartjs'

export default {
  extends: Doughnut,
  props: ['data', 'labels'],
  watch: {
    data: function () {
      this.renderProdutoChart()
    }
  },
  methods: {
    renderProdutoChart () {
      this.renderChart({
        labels: this.labels,
        datasets: [
          {
            backgroundColor: [
              '#2193b0', // Blue
              '#1d976c', // Green
              '#f2994a', // Orange
              '#eb3349', // Red
              '#6a11cb', // Purple
              '#2575fc', // Bright Blue
              '#4b6cb7', // Navy
              '#00b09b', // Teal
              '#8e44ad', // Amethyst
              '#2c3e50'  // Dark
            ],
            data: this.data
          }
        ]
      }, {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          position: 'right',
          labels: {
            boxWidth: 12
          }
        }
      })
    }
  },
  mounted () {
    this.renderProdutoChart()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/producao/producao-dashboard/ProducaoProdutoChart.vue